import type { ReactNode } from 'react';
import { Footer } from './Footer';
import { NavBar } from './NavBar';
import { TopBar } from './TopBar';

export const Chrome = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen bg-navy">
    <TopBar />
    <NavBar />
    {children}
    <Footer />
  </div>
);
